import React from 'react'
import "./MyPurchasesScreen.css"

const MyPurchasesScreen = () => {
  return (
    <div>MyPurchasesScreen</div>
  )
}

export default MyPurchasesScreen